export default "__VITE_ASSET__D_amkXR7__"